import { lazy } from "react";
import { Route } from "react-router-dom";

import { ROUTE_PATHS } from "./paths";
import {
  RedirectAdminToDashboard,
  RequireAuthOrRegisterAddress,
  RequireCustomerAuth,
} from "./guards";

const HomePage = lazy(() => import("../../features/customer/home/pages/HomePage"));
const CategoryPage = lazy(() => import("../../features/customer/products/pages/CategoryPage"));
const ProductPage = lazy(() => import("../../features/customer/products/pages/ProductPage"));
const SearchPage = lazy(() => import("../../features/customer/products/pages/SearchPage"));
const CartPage = lazy(() => import("../../features/customer/cart/pages/CartPage"));
const CheckoutPage = lazy(() => import("../../features/customer/checkout/pages/CheckoutPage"));
const OrderTimePage = lazy(() => import("../../features/customer/checkout/pages/OrderTimePage"));
const GiftPage = lazy(() => import("../../features/customer/checkout/pages/GiftPage"));
const AddressesPage = lazy(() => import("../../features/customer/addresses/pages/AddressesPage"));
const AddressNewPage = lazy(() => import("../../features/customer/addresses/pages/AddressNewPage"));
const AccountPage = lazy(() => import("../../features/customer/account/pages/AccountPage"));
const OrdersPage = lazy(() => import("../../features/customer/orders/pages/OrdersPage"));
const OrderDetailsPage = lazy(() => import("../../features/customer/orders/pages/OrderDetailsPage"));
const BranchesPage = lazy(() => import("../../features/customer/branches/pages/BranchesPage"));
const BranchDetailsPage = lazy(() => import("../../features/customer/branches/pages/BranchDetailsPage"));
const LoginPage = lazy(() => import("../../features/customer/auth/pages/LoginPage"));
const RegisterPage = lazy(() => import("../../features/customer/auth/pages/RegisterPage"));

export const customerRoutes = (
  <>
    <Route
      path={ROUTE_PATHS.home}
      element={
        <RedirectAdminToDashboard>
          <HomePage />
        </RedirectAdminToDashboard>
      }
    />
    <Route
      path={ROUTE_PATHS.category}
      element={
        <RedirectAdminToDashboard>
          <CategoryPage />
        </RedirectAdminToDashboard>
      }
    />
    <Route
      path={ROUTE_PATHS.product}
      element={
        <RedirectAdminToDashboard>
          <ProductPage />
        </RedirectAdminToDashboard>
      }
    />
    <Route
      path={ROUTE_PATHS.search}
      element={
        <RedirectAdminToDashboard>
          <SearchPage />
        </RedirectAdminToDashboard>
      }
    />
    <Route
      path={ROUTE_PATHS.cart}
      element={
        <RequireCustomerAuth>
          <CartPage />
        </RequireCustomerAuth>
      }
    />
    <Route
      path={ROUTE_PATHS.checkout}
      element={
        <RequireCustomerAuth>
          <CheckoutPage />
        </RequireCustomerAuth>
      }
    />
    <Route
      path={ROUTE_PATHS.orderTime}
      element={
        <RequireCustomerAuth>
          <OrderTimePage />
        </RequireCustomerAuth>
      }
    />
    <Route
      path={ROUTE_PATHS.gift}
      element={
        <RequireCustomerAuth>
          <GiftPage />
        </RequireCustomerAuth>
      }
    />
    <Route
      path={ROUTE_PATHS.addresses}
      element={
        <RequireCustomerAuth>
          <AddressesPage />
        </RequireCustomerAuth>
      }
    />
    <Route
      path={ROUTE_PATHS.addressNew}
      element={
        <RequireAuthOrRegisterAddress>
          <AddressNewPage />
        </RequireAuthOrRegisterAddress>
      }
    />
    <Route
      path={ROUTE_PATHS.account}
      element={
        <RequireCustomerAuth redirect={ROUTE_PATHS.login}>
          <AccountPage />
        </RequireCustomerAuth>
      }
    />
    <Route
      path={ROUTE_PATHS.orders}
      element={
        <RequireCustomerAuth>
          <OrdersPage />
        </RequireCustomerAuth>
      }
    />
    <Route
      path={ROUTE_PATHS.orderDetails}
      element={
        <RequireCustomerAuth>
          <OrderDetailsPage />
        </RequireCustomerAuth>
      }
    />
    <Route
      path={ROUTE_PATHS.branches}
      element={
        <RedirectAdminToDashboard>
          <BranchesPage />
        </RedirectAdminToDashboard>
      }
    />
    <Route
      path={ROUTE_PATHS.branchDetails}
      element={
        <RedirectAdminToDashboard>
          <BranchDetailsPage />
        </RedirectAdminToDashboard>
      }
    />
    <Route
      path={ROUTE_PATHS.login}
      element={
        <RedirectAdminToDashboard>
          <LoginPage />
        </RedirectAdminToDashboard>
      }
    />
    <Route
      path={ROUTE_PATHS.register}
      element={
        <RedirectAdminToDashboard>
          <RegisterPage />
        </RedirectAdminToDashboard>
      }
    />
  </>
);






